import forOwn from 'mout/object/forOwn'

export default function initializeAnswers(items, destructuredSubtests) {
  let answers = {}
  forOwn(destructuredSubtests, (val, key, o) => {
    answers[key] = []
    val.items.forEach((item) => {
      const contentItem = items[item]
      let correctAnswer = ''
      forOwn(contentItem.answers, (answer, answerKey, ob) => {
        if (answer.correct) {
          correctAnswer = answerKey
        }
      })
      answers[key].push(correctAnswer)
    })
  })
  return answers
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/initializeAnswers.js